import { render, staticRenderFns } from "./EditStationPage.vue?vue&type=template&id=01a180a5&"
import script from "./EditStationPage.vue?vue&type=script&lang=js&"
export * from "./EditStationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports